import { Box } from '@mui/material'
import { Outlet } from 'react-router'

import Footer from './Footer'
import Header from './Header'
import style from './style'

const Layout: React.FC = () => {
  return (
    <Box sx={style.container}>
      <Header />
      <Box component="main" sx={style.content}>
        <Outlet />
      </Box>
      <Footer />
    </Box>
  )
}

export default Layout
